import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { DeliveryGapsView } from '@lib/guarantees/data-access';
import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { ChipComponent } from '../common/chip.component';
import { DiagnosisChipComponent } from '../common/diagnosis-chip.component';
import { SERVICE_KIND_ICON, SERVICE_KIND_LABEL_KEY, STOP_REASON_ICON, STOP_REASON_LABEL_KEY } from '../common/guarantee-vocabulary';

/**
 * Care the insurer committed to that the member never received. Coverage and delivery are separate
 * axes in the model and each is already reported on its own; only read together do they say an
 * amount was reserved for care that never happened, which no other view surfaces.
 *
 * Read-only. Chasing a gap means booking or cancelling, and both belong to the care plan — this
 * list exists to find them, and hands each one back to the stream.
 */
@Component({
  selector: 'guarantees-delivery-gaps',
  standalone: true,
  imports: [DatePipe, MatIcon, MatTooltip, TranslatePipe, ChipComponent, DiagnosisChipComponent],
  templateUrl: './delivery-gaps.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryGapsComponent {
  gaps = input.required<DeliveryGapsView>();

  guaranteeOpened = output<string>();

  protected readonly kindIcons = SERVICE_KIND_ICON;
  protected readonly kindLabelKeys = SERVICE_KIND_LABEL_KEY;
  protected readonly stopReasonIcons = STOP_REASON_ICON;
  protected readonly stopReasonLabelKeys = STOP_REASON_LABEL_KEY;

  protected readonly total = computed(() => this.gaps().neverPlanned.length + this.gaps().stopped.length);
}
